import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import { Text } from 'components/v4';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const ServicesDropdown = ({
    accountScope,
    submitData,
    setPlatformNumber,
    errors,
    touched,
    darkMode,
    services,
    serviceList,
    platformID,
    section,
    serviceCount,
    isServiceDisabled,
}) => {
    const singleService = serviceCount === 1 ? serviceList[0] : undefined;
    const hasServiceDropdown = serviceCount > 1;
    const platformIndex = submitData?.findIndex(
        (platform) => platform?.platformID === platformID,
    );
    const platform = submitData[platformIndex];

    const handleSelectChange = (item) => {
        setPlatformNumber((prev) => {
            const newPlatformNumbers = [...prev];

            newPlatformNumbers[platformIndex] = {
                ...platform,
                trunkID: item?.id,
            };
            return newPlatformNumbers;
        });
    };

    const [isHovered, setIsHovered] = useState(false);

    let renderLocationField;
    if (isServiceDisabled) {
        renderLocationField = (
            <Stack direction="row" width="100%" alignItems="center" spacing={2}>
                {/* <Switch mb={0} isDisabled isChecked={false} /> */}
            </Stack>
        );
    }
    if (singleService) {
        renderLocationField = (
            <Stack direction="row" width="100%" alignItems="center" spacing={2}>
                <Text>{singleService.name}</Text>
            </Stack>
        );
    }
    if (hasServiceDropdown) {
        renderLocationField = (
            <Field
                component={DropDown}
                id={`${section}-service`}
                name={`${section}-service`}
                shownValue="name"
                currentId={platform?.trunkID}
                handleSelectChange={handleSelectChange}
                accountScope={accountScope}
                darkMode={darkMode}
                data={services}
                walkthroughid={
                    walkthroughIds.editNumbersGeneral.editPlatformNumbers
                        .ufService
                }
            />
        );
    }
    return serviceCount === 0 ? (
        <Box padding="10px 0px"></Box>
    ) : (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                errors &&
                `${section}-service` in errors &&
                touched &&
                touched[`${section}-service`]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Service
                    </FormLabel>
                </Box>
                {renderLocationField}
                {isHovered && (
                    <FieldToolTip
                        label="Services assigned to Operator Platform"
                        ariaLabel={`${section}-service-tooltip`}
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ServicesDropdown;
